module.exports = __webpack_public_path__ + "static/media/icon-planilhas-white.34aab77a.svg";